/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `pending` - 결제 대기
 * `paid` - 결제 완료
 * `failed` - 결제 실패
 * `cancelled` - 취소됨
 */
export type PaymentStatusEnum =
  (typeof PaymentStatusEnum)[keyof typeof PaymentStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentStatusEnum = {
  pending: "pending",
  paid: "paid",
  failed: "failed",
  cancelled: "cancelled",
} as const;
